import React from 'react';
import logo from '../images/logo.svg';

const Header = () => {
  return (
    <div style={{display:"flex",alignItems:"center", justifyContent:"center"}}>
    <img src={logo} className="App-logo" alt="logo" style={{marginTop:"25px", marginBottom:"15px", height:"50px"}} />
    </div>
  );
}

export default Header;
